<template>
	<div class="score-table">
		<el-form :model="ruleForm" ref="ruleForm" label-width="130px">
			<el-table :data="ruleForm.judge_table" :span-method="objectSpanMethod" border fit>
				<el-table-column prop="label" label="四步驟" width="80">
					<template slot-scope="{row}">{{row.label | mapLabel}}</template>
				</el-table-column>
				<el-table-column prop="target" label="指標" />
				<el-table-column prop="achieved" label="達成" width="40">
					<template slot-scope="{row}">
						<el-checkbox v-model="row.achieved"></el-checkbox>
					</template>
				</el-table-column>
			</el-table>
			<el-form-item label="設計思考總和評估">
				<el-radio-group v-model="ruleForm.assessment">
					<el-radio label="有"></el-radio>
					<el-radio label="無"></el-radio>
					<el-radio label="待討論"></el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="備註">
				<el-input v-model="ruleForm.remark" type="textarea" :autosize="{minRows: 3}"></el-input>
			</el-form-item>
		</el-form>
		<div class="btn-box row" align-x="right" align-y="center" gutter="10">
			<span v-if="editStoryData.apply_status == 6" style="color:red">已經由{{ruleForm.judge_name}}送出評分</span>
			<div v-else>
				<span v-if="ruleForm.judge_name" style="color:blue">已由{{ruleForm.judge_name}}暫存</span>
			</div>
			<el-button @click="submit(false)" :disabled="editStoryData.apply_status == 6" type="primary">暫存</el-button>
			<el-button @click="submit(true)" :disabled="editStoryData.apply_status == 6" type="success">送出評分</el-button>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import _ from "lodash";
export default {
	props: {
		ruleForm: {
			type: Object,
			default: () => new Object({
				judge_name: "",
				assessment: "",
				remark: "",
				judge_table: [
					{ label: "F", achieved: false, target: "使用者中心" },
					{ label: "F", achieved: false, target: "定義問題（問題如何發生）" },
					{ label: "I", achieved: false, target: "多元創意（解方數量）" },
					{ label: "I", achieved: false, target: "最終解方（點子是否契合「身體力行」與「原本的問題和使用者」）" },
					{ label: "D", achieved: false, target: "善用資源及有效分工" },
					{ label: "D", achieved: false, target: "調查使用者的改變" },
					{ label: "S", achieved: false, target: "分享完整的故事歷程及結果" },
					{ label: "S", achieved: false, target: "分享的不同管道及方法（傳遞行動的方式）" }
				]
			})
		}
	},
	data() {
		return {
			F: {
				O: "恭喜你們在感受步驟發現了讓人困擾的問題！有時候，造成問題發生的原因會有很多個，我們邀請你可以透過觀察、調查或是實際接觸與問題相關的人，讓我們有更多的蛛絲馬跡去看見問題的不同層面。所以，下次再發現問題時，可以試著找找看造成這個問題的原因有哪些，去思考在這些問題的背後有哪些可觀察到的客觀事實，若是自己的主觀想法，也可以透過更近一步釐清，有哪些證據可以證明自己的論點，這樣的話，你們解決問題的能力就會更上一層樓喔！",
				S: "很開心你們已經開始將自己所發現的問題或困擾列為行動的第一步，你們透過找資料、訪談他人、做問卷統計或是田野觀察等，開始去更認識這個問題，非常值得鼓勵！你們已經為整個行動方案開啟了一扇大門囉！接下來我們想跟你分享，除了開始更認識問題外，還可以再深一步去了解與這個問題相關的人有哪些，透過實際的訪談也可以更了解使用者他們和問題之間有著哪些困擾或期待，這些都很值得我們在感受階段更進一步去探討，這會讓「以人為本」的概念更完整地在感受階段展現出來喔！",
				W: "你們除了感受到了困擾人的問題外，更從問題的不同層面去進行探究與分析，還更進一步的透過同理心去更了解問題的不同關係人與事件的不同面向，再經由你們縝密的分析與層層的推演找出了問題的核心原因是什麼以及重新定義了一次問題，讓問題不再只是本來所設想的，而是更深一層的從使用者的角度讓「以人為本」的探究角度也一併考量進去，使得我們的問題現在更加具體了，這是一件非常厲害的事情！",
			},
			I: {
				O: "你們試著針對發現的問題，提出解決辦法，這是一個充滿勇氣的行為喔！偷偷跟你們分享一個想像的小訣竅，希望對你們以後想方法時有幫助：下次可以試著挑戰，看能不能想像一些平常都沒有想過的方法即使還很天馬行空，甚至也可以挑戰想出就算用 Google 也找不到的方法，這些方法或許乍看都還有些超乎現實，但其實一位具備有想像力和創造力的人都是從這些看似天馬行空的大量發想練習起的。相信，充滿勇氣的你們一定可以挑戰成功的！",
				S: "想像階段就是大量腦力激盪的時間，從你們的故事中，我們看了很多很棒的點子，但有這麼多的好點子該篩選哪一個呢？我們建議可以試著先把點子進行分類，讓同一類的點子先聚集在一起，再一個個去評估和判斷哪些類別的點子最適合現在的我們進行，可能是最不用花預算的，也可能是可以立刻執行的，更可能是我們評估後發現使用者最喜歡的，因此，想像階段加入了篩選機制，也會讓我們天馬行空的點子更加容易被執行喔！",
				W: "你們在想像的步驟，想出了很多有創意而且真的可以執行的點子，可以說你們每個人都是一個創意大師！從你們的點子評估中也看見了，你們用心的去評估每一個點子的落實性，即使是現在還不可能完成的點子，我們也看見你們有試著想出不同的替代方案，這點是非常難能可貴的，希望你們可以保持這顆創意的心，讓更多有創意的想法和點子落實在日常生活中，永遠要記得創造力這項能力會帶你面對未來的大大小小的挑戰喔！",
			},
			D: {
				O: "完成實踐這個步驟，真是辛苦你們了！跟大家分享一個可以比較輕鬆完成實踐步驟的方法，那就是與夥伴進行有效率的團隊合作，以及仔細觀察身邊有哪些可以使用的資源，可能是學校已經有的資源、也可能是我們身邊的每一位可以請教的師長，更可能是我們身邊的夥伴喔，記得看看身邊的夥伴們彼此的長處有哪些，記得相互幫忙和學習。如果在實踐步驟能夠做到團隊合作跟利用身邊資源的話，解決問題的過程就會更加輕鬆喔！",
				S: "除了想到好方法外，謝謝你們更願意開始行動，這是成為超級英雄非常重要的一步喔，在實踐的過程，我們看見小組內每一個夥伴都是彼此的左右手，從整個實踐的歷程中其實自己與團隊夥伴的成長也是相當重要的，每一個的相互磨合、遇到挫折、共同承擔都是學習的機會，也讓計畫開始執行，一邊做一邊修正，我們相信你們的行動力就會因為這次的歷程中慢慢的長出來囉！",
				W: "實踐是一個辛苦的步驟，但謝謝你們都沒有放棄，在實踐歷程中所有喜怒哀樂都會是你們未來的養分，因為不論實踐後的結果如何，我們都相信你們透過與夥伴間的團隊合作、願意自身開始承擔責任，以及妥善利用身邊的資源，這些都是非常不容易的，別忘了在未來也要持續保有實踐歷程的行動力與恆毅力，這樣我想再大的難題都難不了你們了！",
			},
			S: {
				O: "DFC 臺灣團隊看到你們的故事了喔！你們真的很棒，完成了 DFC 四步驟。這麼棒的故事，如果可以讓更多人看到就好了。建議大家，以後可以試試看用更多不同的方式分享你們做過的事情。同時也可以試著把 DFC 四步驟講得更完整。相信，未來的你們一定可以說出更多更讓人熱血沸騰的故事！",
				S: "在分享的步驟，可以嘗試運用不同方式與管道，一種是擴散自己的影響力讓更多人知道原來解決問題從我們自身就可以做起，另一種是可以針對我們所訂下的使用者和議題，還有哪些群體也正受這個議題所苦惱或是他們也很關注你的正在解決的問題，透過分享都可以讓彼此再一次的交流和把經驗分享出去喔！",
				W: "你們在分享步驟，很完整地把參加 DFC 挑戰的經過告訴許多人。因為有你們的分享一定會讓更多人開始相信原來解決問題並不是件搖不及的事情，也因為有你們的分享，我想也會有更多關注這個議題的群體甚至是使用者會被你們的行動感動；因為，這世界上的問題這麼多也永遠不缺只會抱怨的人，但你們是一群願意捲起袖子真實的去在乎且付諸於行動的人，這樣的精神除了透過分享能感染別人，也將會是自己一輩子能珍藏的故事。",
			},
		};
	},
	computed: {
		...mapState('story', ['editStoryData']),
		...mapState('user', ['userInfo']),
		id() {
			return this.$route.params.id || '';
		},
		comments() {
			let arr = [];
			// 各個指標分數
			const Fscore = this.ruleForm.judge_table.filter(o => o.label == 'F').reduce((a, b) => a += b.achieved ? 2 : 0, 1);
			const Iscore = this.ruleForm.judge_table.filter(o => o.label == 'I').reduce((a, b) => a += b.achieved ? 2 : 0, 1);
			const Dscore = this.ruleForm.judge_table.filter(o => o.label == 'D').reduce((a, b) => a += b.achieved ? 2 : 0, 1);
			const Sscore = this.ruleForm.judge_table.filter(o => o.label == 'S').reduce((a, b) => a += b.achieved ? 2 : 0, 1);
			// 前言
			arr.push("Hello! 親愛的超級英雄們好，\n恭喜你們透過 DFC 四步驟，完成了改變世界的挑戰。\n作為 DFC 挑戰在的臺灣主辦單位，DFC 臺灣團隊的成員們很認真地觀賞了貴組的故事影片以及閱讀了貴組的挑戰學習單，而在這屆所有我們收到的故事裡頭，我們看到大家處理的議題各式各樣，而不論你想解決什麼樣的議題，最重要的是，我們在每一位改變世界超級英雄的身上，都看到了一顆想讓世界變得更美好的心。\nDFC 臺灣團隊相信在未來，各位改變世界超級英雄一定會繼續努力改善你們所發現的問題，所以我們想要與各位分享一些小小的訣竅，當作大家在未來嘗試改變世界時的秘密武器。");
			// 依照每個分數加入評語
			if (Fscore == 1) arr.push(this.F.O);
			if (Fscore == 3) arr.push(this.F.S);
			if (Fscore == 5) arr.push(this.F.W);
			if (Iscore == 1) arr.push(this.I.O);
			if (Iscore == 3) arr.push(this.I.S);
			if (Iscore == 5) arr.push(this.I.W);
			if (Dscore == 1) arr.push(this.D.O);
			if (Dscore == 3) arr.push(this.D.S);
			if (Dscore == 5) arr.push(this.D.W);
			if (Sscore == 1) arr.push(this.S.O);
			if (Sscore == 3) arr.push(this.S.S);
			if (Sscore == 5) arr.push(this.S.W);
			// 結尾
			arr.push("我們在每個故事裡面，都看到了大家在參與 DFC 挑戰時，遇到的各種困難以及挫折。很開心的是，在輔導員的陪伴下，你們克服了每一個難關，完成了屬於你們的 DFC 挑戰，相信在這個歷程裡面，大家都成長了許多！\n謝謝大家參與這次的 DFC 挑戰，也希望大家記得謝謝辛苦的輔導員喔！或許未來大家不會繼續參與 DFC 挑戰，但還是可以持續利用感受、想像、實踐、分享，這四個步驟來解決身邊的問題。重點是，遇到問題時永遠都要相信自己 Yes, I can！");
			return arr;
		}
	},
	filters: {
		mapLabel(val) {
			switch (val) {
				case 'F':
					return '感受';
				case 'I':
					return '想像';
				case 'D':
					return '實踐';
				case 'S':
					return '分享';
			}
		}
	},
	methods: {
		...mapMutations('story', ['updateEditStoryData']),
		...mapActions('story', ['fetchEditStory', 'judgeStory']),
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				if (rowIndex % 2 === 0) {
					return {
						rowspan: 2,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},
		async submit(is_submit) {
			if (this.userInfo.role == 'judge') {
				_.assign(this.ruleForm, {
					judge_name: this.userInfo.name,
					comments: this.comments
				});
				const data = _.assign(this.editStoryData, {
					judgement: this.ruleForm
				});
				try {
					this.updateEditStoryData(data);
					await this.judgeStory({ is_submit, data });
					this.$message.success('成功送出');
				} catch (e) {
					this.$message.error(e);
				}
			} else {
				this.$message.error('您不是評審');
			}
		}
	},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.score-table {
	background-color: white;
	padding: 10px;
	width: 500px;
	border: 1px solid #606266;
}
</style>